import React from 'react';

import PropTypes from 'prop-types';

import { Link, Type } from '@nerdwallet/currency';
import Icon from '@nerdwallet/react-icon';

import style from './roundup-link.module.less';

const RoundUpLink = ({ stateRoundupCopy, stateName, stateRoundupUrl }) =>
  !stateRoundupCopy || !stateRoundupUrl ? null : (
    <div className={style.container}>
      <Type size={3} component="h3" bold className={style.heading}>
        {`${stateName}'s best mortgage lenders`}
      </Type>
      <Type className={style.copy}>{stateRoundupCopy}</Type>
      <Type className={style.link}>
        <Link href={stateRoundupUrl} target="_blank">
          See full article
          <Icon icon="navigateright" />
        </Link>
      </Type>
    </div>
  );

RoundUpLink.propTypes = {
  stateRoundupUrl: PropTypes.string.isRequired,
  stateRoundupCopy: PropTypes.string.isRequired,
  stateName: PropTypes.string.isRequired,
};

export default RoundUpLink;
